import styled from "@emotion/styled";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Box, IconButton } from "@mui/material";

import EditIcon from "../../assets/Icons/EditIcon";
import { InvoiceLineItems } from "../../interfaces/Gig";
import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";

const StyledContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  p:nth-child(1) {
    color: ${theme.grey2[400]};
  }
  p:nth-child(2) {
    color: ${theme.black[800]};
  }
`;

interface DisplayInvoiceLineItemProps {
  handleEdit?: () => void;
  handleDelete?: () => void;
  invoiceData: InvoiceLineItems;
  view?: boolean;
}

const DisplayInvoiceLineItem = ({
  handleEdit,
  handleDelete,
  invoiceData,
  view = false,
}: DisplayInvoiceLineItemProps) => {
  return (
    <Box
      sx={{
        backgroundColor: view ? theme.whiteBg.WBG3 : theme.whiteBg.WBG1,
        borderRadius: 2,
        p: 2,
        my: 1,
        position: "relative",
      }}
    >
      {handleEdit && (
        <Box
          sx={{
            position: "absolute",
            top: 3,
            right: 3,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <IconButton onClick={handleEdit}>
            <EditIcon color={theme.brand1[500]} />
          </IconButton>
          <IconButton onClick={handleDelete} sx={{ p: "6px" }}>
            <DeleteOutlineOutlinedIcon
              sx={{ color: theme.brand2[700], fontSize: "20px" }}
            />
          </IconButton>
        </Box>
      )}
      <Typography variant="body3" sx={{ color: theme.black[800], mb: 2 }}>
        {invoiceData.title}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <StyledContainer>
          <Typography variant="small5">Rate</Typography>
          <Typography variant="title2">${invoiceData.rate}</Typography>
        </StyledContainer>
        <StyledContainer>
          <Typography variant="small5">Quantity</Typography>
          <Typography variant="title2">{invoiceData.quantity}</Typography>
        </StyledContainer>
        <StyledContainer>
          <Typography variant="small5">Total</Typography>
          <Typography variant="title2">
            ${invoiceData.rate * invoiceData.quantity}
          </Typography>
        </StyledContainer>
      </Box>
    </Box>
  );
};

export default DisplayInvoiceLineItem;
